import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import postCheckAvailRoleAccessName from 'Api/role/postRoleAvailability';
import { useToast } from 'Store/toast';

import postRoleAvailabilityPayload from './model/request/postRoleAvailabilityPayload';

const usePostRoleAvailability = (setError, clearErrors) => {
  const { t } = useTranslation('role');
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (data) => {
      const payload = postRoleAvailabilityPayload(data);

      const response = await postCheckAvailRoleAccessName({ payload });

      return response;
    },
    onSuccess: () => clearErrors('name'),
    onError: (error) => {
      const { response } = error;
      const errorFields = response?.data?.errorFields;

      if (!isEmpty(errorFields)) {
        setError('name', { type: 'custom', message: errorFields?.name?.message || '' });
        return;
      }

      onOpenToast({
        status: 'error',
        title: t('inlineErrorTitle'),
        duration: 5,
        alwaysShow: false,
      });
    },
  });
};

export default usePostRoleAvailability;